import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Typography, TextField, InputAdornment } from "@mui/material";
import Grid from "@mui/material/Grid2";
import SearchIcon from '@mui/icons-material/Search';
import AccountInquiryList from "./AccountInquiryList";
import AccountInquiryFilter from './AccountInquiryFilter';
import { alertActions } from '_store';
import { accountInquiryData } from '_utils/constant';
import { accountInquiryActions } from '_store/accountInquery.slice'
import {useCheckRole } from '_utils/role-access';
import { ERR_MSG } from 'constants/labels';

const AccountInquiry = () => {
  const header = "Account Inquiry";
  const dispatch = useDispatch();
  // const authUserId = useSelector(x => x.auth?.userId);
  const [data, setData] = useState([]);
  // const [searchInput, setSearchInput] = useState(''); // State for search input
  const [openComponent, setOpenComponent] = useState(null);
  const [backdropOpen, setBackdropOpen] = useState(false);
  const [noRecordMessage,setNoRecordMessage] =useState(null);
  const [searchInput, setSearchInput] = useState('');
  const accountList = accountInquiryData?.Data?.AccountData;

  const NumberWithoutSpecialChar = (input) => {
    // Convert input to string
    const str = String(input);
    if (/^[0-9()\-\s]+$/.test(str)) {
      // Remove ( ) and - and spaces, keep digits only
      return str.replace(/[()\-\s]/g, '');
    }
    return str;
  };


  const handleFilterSubmit = async (isGlobalSearch, data) => {
    let payload = {
      Data: {
        account_Number: null,
        phone_Number: null,
        first_Name: null,
        last_Name: null,
        house_Number: null,
        street: null,
        city: null,
        state: null

      }
    };
  
    if (isGlobalSearch) {
      //const input = typeof data === 'string' ? data.trim() : '';

      const input = NumberWithoutSpecialChar(data);
  
      if (/^\d{10}$/.test(input)) {
        payload.Data.phone_Number = input;
      } else if (/^\d{12}$/.test(input)) {
        payload.Data.account_Number = input;
      } else if (/^[a-zA-Z\s]+$/.test(input)) {
        const nameParts = input.split(' ');
        if (nameParts.length > 1) {
          payload.Data.first_Name = nameParts[0]+"*";
          payload.Data.last_Name = nameParts.slice(1).join(' ')+"*";
        } else {
          payload.Data.first_Name = nameParts[0]+"*";
        }
        // Handle address with commas
} else if (/^[a-zA-Z0-9\s,.-]+$/.test(input)) {
    const cleanedInput = data.trim();

    if (cleanedInput.includes(',')) {
        const firstSpaceIndex = cleanedInput.indexOf(' ');
        const firstCommaIndex = cleanedInput.indexOf(',');

        payload.Data.house_Number = cleanedInput.slice(0, firstSpaceIndex).trim();

        payload.Data.street = cleanedInput.slice(firstSpaceIndex + 1, firstCommaIndex).trim() + '*';

        const afterComma = cleanedInput.slice(firstCommaIndex + 1).trim();

        // Extract state (DC, VA, MD)
        const stateMatch = afterComma.match(/\b(DC|VA|MD)\b/);

        if (stateMatch) {
            const state = stateMatch[1];
            const stateIndex = afterComma.indexOf(state);

            const city = afterComma.slice(0, stateIndex).trim().replace(/,$/, '');
            payload.Data.city = city ? city + '*' : null;

            // State and ZIP; Removed Zip payload
            const zip = afterComma.slice(stateIndex + state.length).trim().replace(/^[-,.\s]+/, '');
            payload.Data.state = state + '*';
        }

    } else { // Handle address without commas
        const parts = cleanedInput.split(/\s+/);

        // Check if input does not contain state abbreviations (VA, DC, MD)
        const hasState = parts.some(part => /^(DC|VA|MD)$/i.test(part));
        if (!hasState) {
            // Treat input as house number and street name
            payload.Data.house_Number = parts[0];
            payload.Data.street = parts.slice(1).join(' ') + '*';
        } else {
            const stateIndex = parts.findIndex(part => /^(DC|VA|MD)$/i.test(part));
            if (stateIndex !== -1) {
                const state = parts[stateIndex].toUpperCase();
                const zip = parts[stateIndex + 1] || '';

                payload.Data.state = state + '*';
                payload.Data.zip = zip ? zip + '*' : null;

                const city = parts.slice(stateIndex - 1, stateIndex).join(' ');
                payload.Data.city = city ? city + '*' : null;

                const street = parts.slice(1, stateIndex - 1).join(' ');
                payload.Data.street = street ? street + '*' : null;
            }
          }
        }
      }
    } else {
      payload = {
        Data: {
          account_Number: data.WashingtonGasAccount,
          phone_Number: data.PhoneNumber,
          first_Name: data.AccountHolder.FirstName?data.AccountHolder.FirstName+"*":"",
          last_Name: data.AccountHolder.LastName?data.AccountHolder.LastName+"*":"",
          house_Number: data.ServiceAddress.HouseNumber,
          street: data.ServiceAddress.StreetAddress?data.ServiceAddress.StreetAddress+"*":"",
          city: data.ServiceAddress.City?data.ServiceAddress.City+"*":"",
          state: data.ServiceAddress.State?data.ServiceAddress.State+"*":""
        }
      };
    }
  
    try {
      dispatch(alertActions.clear());
      const result = await dispatch(
        accountInquiryActions.getInquiryDetails(payload),
      ).unwrap();

      if (result?.Succeeded) {
        const mappedData = result.Data.map((account, index) => ({
          AccountNumber: account.Account_Number,
          AccountHolder: account.Name1,
          SecondaryName: account.Name2 || account.Name1,
          ServiceAddress: `${account.Service_Address1}, ${account.Service_Address2}`,
          BillingAddress: `${account.Billing_Address1}, ${account.Billing_Address2}`,
          PhoneNumber: account.Phone_Number,
          AmountDue: account.Amount_due.trim(),
        }));
        setData(mappedData);
        setNoRecordMessage("");
      } else {
        setData([]);
      }
    } catch (error) {
      setData([]);
      if (!error.message) {
        setNoRecordMessage(error);
      } else {
        dispatch(
          alertActions.error({
            message: error.message ? ERR_MSG["073"] : error,
            header,
          }),
        );
      }
    }
  };

  const handleOpenComponent = (component) => {
    setOpenComponent(prev => prev === component ? null : component);
    setBackdropOpen(prev => prev === component ? false : true);
  };

  const handleCloseBackdrop = () => {
    setBackdropOpen(false);
    setOpenComponent(null);
  };

  return (
    <>
      <Typography component="div" className='userprofilelist '>
        <Grid container direction="row" spacing={2}>
          <Grid size={{ xs: 12, sm: 12, md: 12 }}>
            <Grid container>
              <Grid size={{ xs: 12, sm: 12, md: 4 }}>
                <Typography variant="h2" className='userprofilelistcontent'>Account Inquiry</Typography>
              </Grid>
              <Grid size={{ xs: 12, sm: 12, md: 8 }} >
                <Grid container spacing={2} justifyContent="flex-end" className="MarketerManagement">
                  <Grid size={{ xs: 12, sm: 12, md: 8 }} >
                    <Grid container spacing={2} justifyContent="flex-end">
                      <Grid size={{ xs: 6, sm: 6, md: 4 }}>
                        <AccountInquiryFilter
                          handleFilterSubmit={handleFilterSubmit}
                          isOpen={openComponent === 'filter'}
                          onClose={handleCloseBackdrop}
                          onOpen={() => handleOpenComponent('filter')}
                        />
                      </Grid>

                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>

        </Grid>
      </Typography>

    {useCheckRole(1,"UniversalSearch") && <TextField
        type="text"
        variant="outlined"
        fullWidth
        className="SearchIconinput"
        margin="normal"
        value={searchInput}
        onChange={(e) => setSearchInput(e.target.value)}
        onKeyDown={(e) => {
            if (e.key === 'Enter') {
              handleFilterSubmit(true,searchInput);
            }
          }}
        InputProps={{
          endAdornment: (
            <InputAdornment position="start" onClick={()=>handleFilterSubmit(true,searchInput)}>
              <SearchIcon className="SearchIcon" />
            </InputAdornment>
          ),
          'aria-label': 'search Account Inquiry'
        }}
      />}
      <div className={backdropOpen ? 'backdrop' : ''}>
      </div>
      <div className='MarketerList'>
        <AccountInquiryList
          data={data}
          noRecordMessage={noRecordMessage}
          setData={setData}
          setSearchInput={setSearchInput}
        />

      </div>

    </>
  );
}


export default AccountInquiry;